var _classCallCheck = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/createClass.js");

var _get = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/get.js");

var _inherits = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Declaration = require('../declaration');

var TextEmphasisPosition = /*#__PURE__*/function (_Declaration) {
  "use strict";

  _inherits(TextEmphasisPosition, _Declaration);

  var _super = _createSuper(TextEmphasisPosition);

  function TextEmphasisPosition() {
    _classCallCheck(this, TextEmphasisPosition);

    return _super.apply(this, arguments);
  }

  _createClass(TextEmphasisPosition, [{
    key: "set",
    value: function set(decl, prefix) {
      if (prefix === '-webkit-') {
        decl.value = decl.value.replace(/\s*(right|left)\s*/i, '');
      }

      return _get(_getPrototypeOf(TextEmphasisPosition.prototype), "set", this).call(this, decl, prefix);
    }
  }]);

  return TextEmphasisPosition;
}(Declaration);

TextEmphasisPosition.names = ['text-emphasis-position'];
module.exports = TextEmphasisPosition;